import { withPlugins, domEvents, device, scroll } from '@spon/plugins';

function NewsletterPopup({
	node,
	plugins: { addEvents, removeEvents, device, scroll },
}) {
	let scrollPos = 0;
	let shouldShow = true;
	let height = document.body.offsetHeight - window.innerHeight;
	let shouldLockBody = false;

	function lockBody() {
		document.body.classList.add(
			'overflow-hidden',
			'h-screen',
			'pointer-events-none',
			'fixed',
			'overflow-touch'
		);
	}

	function unlockBody() {
		document.body.classList.remove(
			'overflow-hidden',
			'h-screen',
			'pointer-events-none',
			'fixed',
			'overflow-touch'
		);
	}

	function openPopup() {
		node.classList.add('show');
		node.querySelector('.o-input')?.focus();
		scrollPos = window.scrollY;

		if (shouldLockBody) {
			lockBody();
		}
	}

	function setCookie() {
		const d = new Date();
		d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);

		document.cookie = `hideNewsletterPopup=true; expires=${d.toGMTString()}; path=/`;
	}

	function onClickClose() {
		setCookie();

		node.classList.remove('show');

		if (shouldLockBody) {
			unlockBody();
			window.scrollTo(0, scrollPos);
		}

		node.remove();
		scroll.destroy();
		device.cancel();
		removeEvents();
	}

	function cookieCheck() {
		if (document.cookie.indexOf('hideNewsletterPopup=') >= 0) {
			setCookie();
			node.remove();
			scroll.destroy();
			device.cancel();
			removeEvents();

			return;
		} else {
			addEvents({
				'click [data-popup-closer]': onClickClose,
			});

			device.at('(max-width:1024px)', {
				on: () => {
					shouldLockBody = true;
				},

				off: () => {
					shouldLockBody = false;
					unlockBody();
					window.scrollTo(0, scrollPos);
				},
			});

			scroll.progress(({ y }) => {
				if (y > height * 0.3) {
					openPopup();
					shouldShow = true;
				}
			});
		}
	}

	cookieCheck();
}

export default withPlugins(domEvents, device, scroll)(NewsletterPopup);
